export default function ( requiredFields, settings ) {
	let emptyFields = [];

	requiredFields.forEach(el => {
		if (settings[el.field] !== undefined && !settings[el.field] ) {
			emptyFields.push(el);
		}

		if (el.field === 'method') {
			let emptyMethod = settings.endpoints.filter(endpoint => !endpoint.method);

			if ( emptyMethod.length > 0 ) {
				emptyFields.push(el);
			}
		}
	});

	return { requiredEmptyFields: emptyFields };
}